import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import {
  HttpBusStopLayout,
  HttpBusStopLayoutInfo,
  IBusStopLayoutInfoParser,
} from "../lineInfoRepository.types";
import {
  IBusStopLayout,
  IBusStopLayoutInfo,
} from "@/domain/entities/lineInfo/busStopLayout.types";
import { BusStopLayoutInfo } from "@/domain/entities/lineInfo/busStopLayout";

function parseBusStopLayout(data: HttpBusStopLayout): IBusStopLayout {
  return {
    onGateYn: data.onGateYn,
    floorNo: data.floorNo,
    rowNo: data.rowNo,
    columnNo: data.columnNo,
    gateNo: data.gateNo,
    gateNoGroup: data.gateNoGroup,
  };
}

@injectable()
export class BusStopLayoutInfoParser implements IBusStopLayoutInfoParser {
  constructor() {}

  toDomain(
    data: HttpBusStopLayoutInfo
  ): Result<IBusStopLayoutInfo, ParseError> {
    try {
      const layoutList: IBusStopLayout[][][] =
        data.stationLayout?.map((floorLayout) => {
          return floorLayout.map((rowLayout) => {
            return rowLayout.map((columnLayout) => {
              return parseBusStopLayout(columnLayout);
            });
          });
        }) ?? [];

      const layoutInfoData: IBusStopLayoutInfo = {
        lineTurnUid: data.lineTurnUid,
        lineStationUid: data.lineStationUid,
        lineStationName: data.lineStationName,
        arrivalTime: data.arrivalTime,
        departureTime: data.departureTime,
        order: data.stationOrder,
        onYn: data.onYn,
        offYn: data.offYn,
        returnYn: data.returnYn,
        coreYn: data.coreYn,
        transYn: data.transYn,
        beginYn: data.beginYn,
        finalYn: data.finalYn,
        endYn: data.endYn,
        gateNo: data.gateNo,
        campusCode: data.campusCode,
        campusName: data.campusName,
        layoutList,
      };
      const layoutInfo = new BusStopLayoutInfo(layoutInfoData);
      return ok(layoutInfo);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
